<template>
  <div>
    <!-- <Search class="mr-2 mb-3" /> -->
    <div class="row align-items-end">
      <div class="col-auto flex-grow-1">
        <div class="form-group">
          <label for="select_1_1">Страна <span>*</span></label>
          <select
            class="form-control"
            id="select_1_1"
            v-model="country.val"
            @change="countrySelect"
            :disabled="country.disabled"
            required
          >
            <option value="0" selected disabled>-- выбрать страну --</option>
            <template v-if="country.items != null">
              <option
                v-for="item in country.items"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name_kg }}
              </option>
            </template>
          </select>
        </div>
      </div>

      <div class="col-auto">
        <button
          class="btn btn-primary mb-4 ml-auto d-block"
          style="white-space: nowrap"
          @click="addModalShow"
          :class="{ 'is-loading': !isAddActive }"
        >
          Добавить
        </button>
      </div>
    </div>
    <hr class="mt-0 mb-2" />
    <template v-if="oblast.items.length">
      <div class="row align-items-center">
        <div class="col-auto mb-2" v-if="newSearchList.length">
          <PerPageLenth
            class="mr-3"
            :page="page"
            :perPage="perPage"
            :allDataLenth="newSearchList.length"
          />
          <PerPageCount :perPage="perPage" @perPageSet="perPageSet" />
        </div>
        <div class="col-auto ml-auto mb-2">
          <div class="row">
            <div class="col-auto">
              <div class="input-affix">
                <i class="prefix-icon anticon anticon-search"></i>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="searchText"
                  placeholder="Поиск"
                />
              </div>
            </div>
            <div class="col-auto">
              <button
                class="btn btn-sm btn-icon btn-secondary btn-tone excel"
                :disabled="!newSearchList.length"
                :class="{ excelHide: !newSearchList.length }"
                @click="downloadFile"
              >
                <i class="anticon anticon-file-excel"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-0 mb-2" />
    </template>
    <template v-if="newSearchList.length">
      <table
        class="table table-sm table-responsive-md table-striped table-hover"
      >
        <thead class="">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Кыргызча</th>
            <th scope="col">Русский</th>
            <th scope="col">English</th>
            <th scope="col" class="text-center" style="white-space: nowrap">
              Ин.
            </th>

            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in newDatalist" :key="item.id">
            <th scope="row">{{ index + perPage * (page - 1) + 1 }}</th>
            <td>{{ item.name_kg }}</td>
            <td>{{ item.name_ru }}</td>
            <td>{{ item.name_en }}</td>
            <td class="text-center">{{ item.id_integration }}</td>

            <td class="text-right">
              <!-- <button class="btn btn-primary btn-xs mr-1">btn-xs</button> -->
              <button
                class="btn btn-icon btn-sm btn-success btn-tone mr-1 mb-1 mb-lg-0"
                @click="editModalShow(index)"
              >
                <i class="anticon anticon-edit"></i>
              </button>
              <button
                class="btn btn-icon btn-sm btn-danger btn-tone"
                @click="deleteModalShow(index, item.id)"
              >
                <i class="anticon anticon-delete"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </template>
    <div v-else class="noTdData">Нет данных</div>
    <Pagination
      :total="newSearchList.length"
      :perPage="perPage"
      @activePage="currentPage"
    />
    <Modal :isShow="isAddModalShow" @closeModal="addModalClose">
      <template v-slot:title> Добавить область </template>
      <template>
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="oblast.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="oblast.val.name_ru"
            required
          />
        </div>

        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="oblast.val.name_en"
            required
          />
        </div>

        <div class="form-group">
          <label for="in_1">№ Интеграции</label>
          <input
            type="text"
            class="form-control"
            id="in_1"
            v-model="oblast.val.id_integration"
            required
          />
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="addModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="oblastPost">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isEditModalShow" @closeModal="editModalClose">
      <template v-slot:title> Изменить область </template>
      <template>
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="oblast.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="oblast.val.name_ru"
            required
          />
        </div>
        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="oblast.val.name_en"
            required
          />
        </div>
        <div class="form-group">
          <label for="in_1">№ Интеграции</label>
          <input
            type="text"
            class="form-control"
            id="in_1"
            v-model="oblast.val.id_integration"
            required
          />
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="editModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="edtoblast">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isDeleteModalShow" @closeModal="deleteModalClose">
      <template v-slot:title> Удалить область </template>

      <template>
        <h5>Вы действительно хотите удалить?</h5>
        <template v-if="newDatalist.length && dindex != null">
          <p>{{ newDatalist[dindex].name_kg }}</p>
          <p>{{ newDatalist[dindex].name_ru }}</p>
          <p>{{ newDatalist[dindex].name_en }}</p>
        </template>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="deleteModalClose"
        >
          Отмена
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click.prevent="deleteblast"
        >
          Подтвердить
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import xlsx from "json-as-xlsx";

import Pagination from "@/components/others/Pagination.vue";
import PerPageLenth from "@/components/others/PerPageLenth.vue";
import PerPageCount from "@/components/others/PerPageCount.vue";
import Modal from "@/components/others/Modal.vue";

export default {
  name: "Oblast",
  components: {
    Pagination,
    PerPageLenth,
    PerPageCount,
    Modal,
  },
  data() {
    return {
      isAddModalShow: false,
      isEditModalShow: false,
      isDeleteModalShow: false,
      country: { disabled: true, items: null, val: 0 },
      oblast: { disabled: true, items: [], val: {} },
      dindex: null,
      did: null,
      page: 1,
      perPage: 10,
      searchText: "",
      isAddActive: false,
    };
  },
  computed: {
    newSearchList() {
      const regEx = new RegExp(this.searchText, "i");
      return this.oblast.items.filter((x) => x.name_kg.match(regEx));
    },
    newDatalist() {
      return this.newSearchList.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  methods: {
    currentPage(i) {
      this.page = i;
    },
    perPageSet(count) {
      this.perPage = count;
    },
    downloadFile() {
      let data = [
        {
          sheet: "Область",
          columns: [
            { label: "#", value: "id" },
            { label: "Кыргызча", value: "name_kg" },
            { label: "Русский", value: "name_ru" },
            { label: "English", value: "name_en" },
            { label: "Интеграция", value: "id_integration" },
          ],
          content: this.newSearchList,
        },
      ];
      let settings = {
        fileName: "Область",
      };
      xlsx(data, settings);
    },
    addModalShow() {
      this.oblast.val = {};
      this.isAddModalShow = true;
    },
    addModalClose() {
      this.isAddModalShow = false;
    },
    editModalShow(index) {
      this.oblast.val = { ...this.newDatalist[index] };
      this.isEditModalShow = true;
    },
    editModalClose() {
      this.isEditModalShow = false;
    },
    deleteModalShow(index, id) {
      this.isDeleteModalShow = true;
      this.dindex = index;
      this.did = id;
    },
    deleteModalClose() {
      this.isDeleteModalShow = false;
    },
    async getcountry() {
      try {
        const data = (await this.$api.place.country()).data;
        this.country.items = data;
        this.country.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getoblast() {
      try {
        const data = (
          await this.$api.place.oblast({
            id_country: this.country.val,
          })
        ).data;
        this.oblast.items = data;
        this.oblast.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },

    async add_oblast() {
      try {
        await this.$api.placeSchool.add_oblast({
          id_country: this.country.val,
          ...this.oblast.val,
        });
        this.$nt("Успешно сохранен", "success");
        this.oblast.val = {};
        this.getoblast();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка сохранения", "dagner");
      }
    },
    async update_oblast() {
      try {
        await this.$api.placeSchool.update_oblast(this.oblast.val);
        this.$nt("Успешно изменен", "success");
        this.oblast.val = {};
        this.getoblast();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка изменения", "dagner");
      }
    },
    async delete_oblast() {
      try {
        await this.$api.placeSchool.delete_oblast({ id: this.did });
        this.$nt("Успешно удален", "success");
        this.dindex = null;
        this.getoblast();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка удаления", "dagner");
      }
    },
    countrySelect() {
      this.isAddActive = true;
      this.oblast.items = [];
      this.searchText = "";
      this.getoblast();
    },
    oblastPost() {
      this.add_oblast();
      this.addModalClose();
    },
    edtoblast() {
      this.update_oblast();
      this.editModalClose();
    },
    deleteblast() {
      this.delete_oblast();
      this.deleteModalClose();
    },
  },

  mounted() {
    this.$nextTick(function () {
      this.getcountry();
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
</style>
